import { render, staticRenderFns } from "./OrderRefund.vue?vue&type=template&id=5453390d"
import script from "./OrderRefund.vue?vue&type=script&lang=js"
export * from "./OrderRefund.vue?vue&type=script&lang=js"
import style0 from "./OrderRefund.vue?vue&type=style&index=0&id=5453390d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports